import { Injectable } from '@angular/core';
import { loadStripe, Stripe, StripeElements, StripePaymentElement } from '@stripe/stripe-js';
import { ApiService } from '@uranda/commons';

@Injectable({
  providedIn: 'root'
})
export class StripeService extends ApiService {
  private stripe: Stripe | null = null;
  private elements: StripeElements | null = null;
  private paymentElement: StripePaymentElement | null = null;

  /**
   * Carica Stripe con la publishable key dal backend e monta il Payment Element
   * nel container HTML specificato.
   */
  async init(clientSecret: string, mountElement: HTMLElement): Promise<void> {
    // Recupera la publishable key dal backend se non ancora fatto
    if (!this.stripe) {
      const configRes = await this.get('/v1/wallet/config');
      const publishableKey: string = configRes.data.publishableKey;
      this.stripe = await loadStripe(publishableKey);
    }

    if (!this.stripe) {
      throw new Error('Stripe is not initialized');
    }

    // Distruggi Elements precedente se esiste
    this.destroy();

    this.elements = this.stripe.elements({
      clientSecret,
      appearance: { theme: 'stripe' }
    });

    this.paymentElement = this.elements.create('payment');
    this.paymentElement.mount(mountElement);
  }

  /**
   * Conferma il pagamento lato client.
   * Restituisce un oggetto con `error` in caso di fallimento.
   */
  async confirmPayment(): Promise<{ error?: { message: string } }> {
    if (!this.stripe || !this.elements) {
      return { error: { message: 'Stripe is not ready' } };
    }

    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      redirect: 'if_required'
    });

    if (error) {
      return { error: { message: error.message ?? 'Payment failed' } };
    }

    return {};
  }

  /**
   * Distrugge il Payment Element corrente.
   */
  destroy(): void {
    if (this.paymentElement) {
      this.paymentElement.destroy();
      this.paymentElement = null;
    }
    this.elements = null;
  }
}

